var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTagPurple(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_202_124",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 25,
    height: 25
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.605469,
    y: 0.576172,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_202_124)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.60547 20.5762L7.60547 16.5762H4.10547L4.60547 14.5762H8.10547L9.10547 10.5762H5.10547L5.60547 8.57617H9.60547L10.6055 4.57617H12.6055L11.6055 8.57617H15.6055L16.6055 4.57617H18.6055L17.6055 8.57617H21.1055L20.6055 10.5762H17.1055L16.1055 14.5762H20.1055L19.6055 16.5762H15.6055L14.6055 20.5762H12.6055L13.6055 16.5762H9.60547L8.60547 20.5762H6.60547ZM10.1055 14.5762H14.1055L15.1055 10.5762H11.1055L10.1055 14.5762Z",
    fill: "#763FF9"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTagPurple);
export default __webpack_public_path__ + "static/media/tag_purple.9f63de8d4146ee3b13ebe905fac032e0.svg";
export { ForwardRef as ReactComponent };